/**
 * Payment Cancel Page
 * 
 * Shown when user cancels PayFast payment
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PaymentCancel.css';

const PaymentCancel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="payment-cancel">
      <div className="cancel-container">
        <div className="cancel-icon">⚠️</div>
        <h1>Payment Cancelled</h1>
        <p className="cancel-message">
          Your payment was cancelled. No charges were made to your account.
        </p>
        <p className="cancel-hint">
          You can try again at any time from your dashboard.
        </p>

        <div className="cancel-actions">
          <button onClick={() => navigate('/dashboard')} className="dashboard-button">
            Return to Dashboard
          </button>
          <button onClick={() => window.history.back()} className="try-again-button">
            Try Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;

